export default __webpack_public_path__ + "static/media/TitilliumWeb-ExtraLight.2d07e99a.ttf";